import { render } from "./ServicesPage.vue?vue&type=template&id=7dc27e0c&scoped=true"
import script from "./ServicesPage.vue?vue&type=script&lang=js"
export * from "./ServicesPage.vue?vue&type=script&lang=js"

import "./ServicesPage.vue?vue&type=style&index=0&id=7dc27e0c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7dc27e0c"]])

export default __exports__